<template>
  <div>
    <div style="text-align: right">
      <div style="margin-right: 20px">
        {{ $t("organstructure.fleetName") }}：
        <el-input :size="size" style="width: 180px; font-size: 12px" clearable
          :placeholder="$t('organstructure.inputfleetName')" v-model="fleetName">
        </el-input>
        <el-button style="margin-left: 30px; cursor: pointer" :size="size" @click="search(fleetName)" plain
          type="primary">{{ $t("public.query") }}</el-button>
        <el-button style="margin-left: 15px; cursor: pointer" :size="size" @click="add" type="primary">{{
          $t("public.add") }}</el-button>
      </div>
    </div>
    <div style="display: flex; flex-direction: row">
      <div>
        <i style="vertical-align: -9%" class="iconfont icon-icon_tab_list"></i>
        <span style="
            margin-top: 20px;
            margin-left: 10px;
            font-size: 12px;
            font-weight: bold;
          ">{{ $t("organstructure.fleetlist") }}</span>
      </div>
    </div>

    <div style="margin-top: 20px">
      <el-table border :size="size" ref="multipleTable" :data="tableData" tooltip-effect="dark" max-height="386"
        style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column :label="$t('public.index')" type="index" width="60" align="center">
        </el-table-column>
        <el-table-column prop="fleetname" :label="$t('organstructure.fleetName')" width="250" align="center">
        </el-table-column>
        <el-table-column prop="fleetcontacts" :label="$t('organstructure.contacts')" show-overflow-tooltip width="100"
          align="center">
        </el-table-column>
        <el-table-column prop="fleettelephone" :label="$t('operatormgr.mobileTel')" show-overflow-tooltip width="120"
          align="center">
        </el-table-column>
        <el-table-column prop="fleetintroduction" :label="$t('organstructure.routeintroduction')" show-overflow-tooltip
          align="center">
        </el-table-column>
        <el-table-column :label="$t('public.Operation')" align="center" width="180">
          <template slot-scope="scope">
            <el-button :size="size" type="success" @click="modify(scope.$index, scope.row)">{{ $t("public.edit")
              }}</el-button>
            <el-button :size="size" type="danger" @click="handleDelete(scope.$index, scope.row)">{{ $t("public.del")
              }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog class="andoffice" :title="fleettitle" :visible.sync="dialogFormVisible"
      :width="LanguageId == 1 ? '400px' : '460px'" :close-on-click-modal="false"
      style="font-size: 14px; text-align: center">
      <el-divider></el-divider>
      <el-form :model="fleetInfo" :label-position="labelPosition" :size="size"
        :label-width="LanguageId == 1 ? '100px' : '160px'" :rules="rules" ref="fleetInfo"
        style="margin-top: 26px; margin-right: 20px">
        <el-form-item :label="$t('organstructure.fleetName') + '：'" prop="fleetname">
          <el-input v-model="fleetInfo.fleetname" :placeholder="$t('organstructure.inputfleetName')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('organstructure.superiorUnit') + '：'" style="margin-top: 15px" prop="superiorunit">
          <el-select v-model="fleetInfo.superiorunit" :placeholder="$t('organstructure.selectsuperiorUnit')" style="width: 240px;"
            @change="selectchange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('organstructure.contacts') + '：'" style="margin-top: 15px">
          <el-input v-model="fleetInfo.fleetcontacts" :placeholder="$t('organstructure.inputlinecontacts')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('operatormgr.mobileTel') + '：'" style="margin-top: 15px" prop="fleettelephone">
          <el-input v-model="fleetInfo.fleettelephone" oninput="if(value.length>11)value=value.slice(0,11)"
            onkeyup="this.value = this.value.replace(/[^\d]/g,'');"
            :placeholder="$t('organstructure.inputtelphone')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('organstructure.fleetintroduction') + '：'" prop="desc" style="margin-top: 15px">
          <el-input type="textarea" v-model="fleetInfo.fleetintroduction"
            :placeholder="$t('organstructure.inputfleetintroduction')"></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right; margin-top: 30px">
        <el-button :size="size" @click="dialogFormVisible = false">{{
          $t("public.cancel")
        }}</el-button>
        <el-button :size="size" type="primary" @click="save('fleetInfo')">{{
          $t("public.save")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import language from "@/utils/getLanguageId";
import { EventBus } from "@/utils/event-bus.js";
import { setVehicles } from "@/utils/auth";
import { mapState } from "vuex";
export default {
  data() {
    return {
      LanguageId: 1,
      fleettitle: "",
      fleetName: "",
      value: "",
      labelPosition: "right",
      dialogFormVisible: false,
      tableData: [],
      options: [],
      fleetInfo: {
        fleetname: "",
        fleetcontacts: "",
        fleettelephone: "",
        fleetintroduction: "",
        superiorunit: ""
      },
      deleteId: [],
      selectvalue: 0,
      rules: {
        fleetname: [
          {
            required: true,
            message: this.$t("organstructure.inputfleetName"),
            trigger: "blur",
          },
        ],
        superiorunit: [
          {
            required: true,
            message: this.$t("organstructure.selectsuperiorUnit"),
            trigger: "change",
          },
        ],
        fleettelephone: [
          {
            pattern: /^1[3456789]\d{9}$/,
            message: this.$t("drivermanagement.inputphone"),
            trigger: "blur",
          },
        ],
      },
      loading: false // 添加加载状态
    };
  },
  computed: {
    ...mapState({
      operator: (state) => state.user.operator,
      size: (state) => state.app.size,
    }),
  },
  mounted() {
    this.queryfleetlist();
    this.LanguageId = language(this.$store.getters.locale);
  },
  methods: {
    // 查询上级单位列表
    queryBranchInfo() {
      this.loading = true;
      return this.$api
        .queryBranchInfo({
          companyID: this.operator.CompanyId,
        })
        .then((res) => {
          if (res && res.code == 200) {
            const newArr = res.data.map((item) => {
              return {
                value: item.branchofficeID,
                label: item.branchname,
              };
            });
            this.options = newArr;
            // 设置默认选择的上级单位
            if (newArr.length > 0 && !this.fleetInfo.superiorunit) {
              this.fleetInfo.superiorunit = newArr[0].value;
            }
            console.log("查询上级单位成功:", this.options);
            return res;
          }
        })
        .catch(error => {
          console.error("查询上级单位失败:", error);
          this.$message.error(this.$t("organstructure.queryBranchFailed"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    selectchange(val) {
      console.log(val);
      this.selectvalue = val;
    },
    
    queryfleetlist() {
      this.$api
        .queryFleetInfo({
          companyID: this.operator.CompanyId,
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            this.tableData = res.data;
          }
        });
    },
    
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
      console.log(selection);
      this.deleteId = selection.map((item) => item.fleetID);
    },
    
    // 修改添加方法
    async add() {
      try {
        this.fleettitle = this.$t("organstructure.addfleet");
        
        // 显示加载状态
        this.loading = true;
        
        // 访问queryBranchInfo接口
        await this.queryBranchInfo();
        
        // 重置表单数据
        this.fleetInfo = {
          fleetname: "",
          fleetcontacts: "",
          fleettelephone: "",
          fleetintroduction: "",
          superiorunit: this.options.length > 0 ? this.options[0].value : ""
        };
        
        // 显示弹窗
        this.dialogFormVisible = true;
        
        // 清除验证
        this.$nextTick(() => {
          if (this.$refs["fleetInfo"]) {
            this.$refs["fleetInfo"].clearValidate();
          }
        });
        
      } catch (error) {
        console.error("添加车队时出错:", error);
        this.$message.error(this.$t("organstructure.addFleetFailed"));
      } finally {
        this.loading = false;
      }
    },
    
    open3(message1) {
      this.$message({
        message: message1,
        type: "warning",
      });
    },
    
    // 修改编辑方法，也查询上级单位
    async modify(index, row) {
      try {
        this.fleettitle = this.$t("organstructure.modifyfleet");
        
        // 显示加载状态
        this.loading = true;
        
        // 访问queryBranchInfo接口确保数据最新
        await this.queryBranchInfo();
        
        // 复制行数据
        const rowCopy = JSON.parse(JSON.stringify(row));
        
        // 处理上级单位的值
        if (rowCopy.superiorunit) {
          // 如果superiorunit是文本，需要转换为值
          const foundOption = this.options.find(option => 
            option.label === rowCopy.superiorunit || option.value === rowCopy.superiorunit
          );
          if (foundOption) {
            rowCopy.superiorunit = foundOption.value;
          }
        }
        
        this.fleetInfo = rowCopy;
        
        // 显示弹窗
        this.dialogFormVisible = true;
        
        console.log("编辑车队:", this.fleetInfo);
        
      } catch (error) {
        console.error("编辑车队时出错:", error);
        this.$message.error(this.$t("organstructure.modifyFleetFailed"));
      } finally {
        this.loading = false;
      }
    },
    
    save(formName) {
      var newValue = this.fleetInfo;
      console.log(newValue);
      
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.fleettitle == this.$t("organstructure.addfleet")) {
            this.changefleetstate(newValue, 0, 1);
          } else if (this.fleettitle == this.$t("organstructure.modifyfleet")) {
            var newaddId = this.fleetInfo.fleetID.toString();
            this.changefleetstate(newValue, newaddId, 2);
          }
        } else {
          return false;
        }
      });
    },
    
    handleDelete(index, row) {
      var newdeleteId = row.fleetID.toString();
      var selectfleetinfo = {};
      this.$confirm(
        this.$t("organstructure.Deletefleet"),
        this.$t("public.tips"),
        {
          confirmButtonText: this.$t("public.confirm"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.changefleetstate(selectfleetinfo, newdeleteId, 3);
        })
        .catch(() => {
          // 取消删除
        });
    },
    
    search(val) {
      this.$api
        .queryFleetInfo({
          companyID: this.operator.CompanyId,
          BranchName: val,
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            this.tableData = res.data;
          }
        });
    },
    
    open2(message) {
      this.$message({
        message: message,
        type: "success",
      });
    },
    
    updatetree() {
      this.$api
        .queryVehicleTreeInfo({
          OperatorID: this.$store.getters.operator.OperatorId,
          CompanyID: this.$store.getters.operator.CompanyId,
        })
        .then((res) => {
          var tree = {};
          res.vehicles.forEach((element) => {
            element.isChecked = false;
            tree[element.id] = element;
          });
          this.$store.dispatch("app/updateVehicleTree", {
            tree,
            rootId: res.vehicles[0].id,
          });
          this.$store.dispatch("app/updateVehicleData", res.vehicles);
          setVehicles(JSON.stringify(res.vehicles));
          EventBus.$emit("initVehicleTree");
        });
    },
    
    //添加、修改、删除车队
    changefleetstate(newfleetinfo, newfleetid, operatevalue) {
      this.$api
        .saveFleetInfo({
          companyID: this.operator.CompanyId,
          OptID: this.operator.OperatorId,
          fleetID: newfleetid,
          fleetname: newfleetinfo.fleetname,
          superiorunit: newfleetinfo.superiorunit,
          fleetcontacts: newfleetinfo.fleetcontacts,
          fleettelephone: newfleetinfo.fleettelephone,
          fleetintroduction: newfleetinfo.fleetintroduction,
          operate: operatevalue,
        })
        .then((res) => {
          console.log(res);
          if (res && res.code == 200) {
            this.dialogFormVisible = false;
            this.queryfleetlist();
            this.updatetree();
            if (operatevalue == 1) {
              this.open2(this.$t("public.add_success"));
            } else if (operatevalue == 2) {
              this.$store.dispatch("app/updateVehicleGroup", {
                groupid: newfleetid,
                groupid: this.selectvalue,
              });
              this.open2(this.$t("public.edit_success"));
            } else if (operatevalue == 3) {
              this.open2(this.$t("operatormgr.del_success"));
            }
          } else {
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
  },
};
</script>